/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var NoteIcon = createIcon("NoteIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 48H3.984C1.784 48 0 46.206 0 43.99V4.01A4.01 4.01 0 014.01 0h39.98C46.205 0 48 1.787 48 3.984V30L30 48Z",
    fill: "#FAC91F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 30 30 48V33.995A3.997 3.997 0 0133.995 30H48Z",
    fill: "#D69600"
  }));
}, {
  "i18nKey": "svg.NoteIcon"
});